import { IS_AUTOLOGIN } from "@web/components/Auth/LoginForm"
import { sendMessageSecure } from "@web/context/WindowMessageContext"
import { Session } from "next-auth"
import { GQL } from "platform-common/index"
import { AuthenticateWithTokenSecureMessage } from "platform-common/types/extension"
import { BrowserMessageType } from "platform-common/types"
import * as React from "react"
import { useRouter } from "next/router"

export function useExtensionAuthFlow() {
  const [getToken] = GQL.useGenerateAuthChallengeTokenMutation()
  const { query } = useRouter()
  const hasRedirect = !!query.callbackUrl

  const beginExtensionAuthFlow = React.useCallback(
    async (session: Session) => {
      if (!session?.user.username) {
        console.warn("No session to authenticate extension with")
        return
      }

      const { data, errors } = await getToken()
      if (errors) {
        console.error("Failed to get auth challenge token:", errors)
        return
      }

      // get auth challenge response token from server
      const authToken = data!.generateAuthChallengeToken.token

      // send token to extension so it can sign itself in
      await sendMessageSecure({
        message: BrowserMessageType.AuthenticateWithToken,
        authToken,
        username: session.user.username,
        email: session.user.email,
      } satisfies AuthenticateWithTokenSecureMessage)

      // if we were doing the auth flow, let's close this tab to return the user to where they were
      const isAutoLogin =
        sessionStorage.getItem(IS_AUTOLOGIN) === "true" || window.location.search.includes("autoLogin=true")
      if (isAutoLogin && !hasRedirect) {
        window.postMessage({ message: BrowserMessageType.RestoreLastActiveTab }, "*")
        sessionStorage.removeItem(IS_AUTOLOGIN)
      }
    },
    [getToken, hasRedirect]
  )

  return { beginExtensionAuthFlow }
}
